<template>
  <div class="activity-page">
    <front-navigation></front-navigation>

    <div class="activity-container">
      <!-- Image Gallery Section -->
      <div class="gallery-section">
        <div v-if="inventoryImages && inventoryImages.length > 0" class="gallery-container">
          <carousel :autoplay="true" :autoplayTimeout="3000" :autoplayHoverPause="true" :perPage="1">
            <slide v-for="(image, key) in inventoryImages" :key="key">
              <img :src="image.path" class="gallery-image" alt="Activity image">
            </slide>
          </carousel>
        </div>
        <div v-else class="single-image-container">
          <img :src="singleInventory.thumbnail" class="gallery-image" alt="Activity thumbnail">
        </div>
      </div>

      <!-- Activity Details Section -->
      <div class="details-section">
        <div class="details-header">
          <h1 class="activity-title earthwerk-font">{{singleInventory.name}}</h1>

          <div class="price-display" v-if="singleInventory.ranger_marker === false">
            <div class="price-item">
              <span class="price-label">Child Price:</span>
              <span class="price-value">{{$localCurrency}} {{$roundOff(convert1(singleInventory.price.currency_type, singleInventory.price.child_price).amount)}}</span>
            </div>
            <div class="price-item">
              <span class="price-label">Adult Price:</span>
              <span class="price-value">{{$localCurrency}} {{$roundOff(convert1(singleInventory.price.currency_type, singleInventory.price.adult_price).amount)}}</span>
            </div>
          </div>
          <div class="price-display" v-else>
            <div class="price-item">
              <span class="price-label">Ranger Price:</span>
              <span class="price-value">{{$localCurrency}} {{$roundOff(convert1(singleInventory.price.currency_type, singleInventory.price.adult_price).amount)}}</span>
            </div>
          </div>
        </div>

        <div class="description-section" v-html="singleInventory.description"></div>

        <v-btn color="primary"
               large
               dark
               class="book-now-btn earthwerk-font"
               @click="dialog = true">
          BOOK NOW
        </v-btn>
      </div>
    </div>

    <!-- Booking Dialog -->
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card class="booking-dialog">
        <v-card-title class="dialog-header">
          <h2 class="earthwerk-font">BOOKING DETAILS</h2>
        </v-card-title>

        <v-card-text class="dialog-content">
          <v-tabs color="primary" dark slider-color="primary">
            <v-tab key="conservation" class="earthwerk-font">Conservation Fees</v-tab>
            <v-tab key="availability" class="earthwerk-font">Availability</v-tab>

            <!-- Conservation Fees Tab -->
            <v-tab-item key="conservation">
              <div class="tab-content">
                <div class="notice-text">
                  * If you have already booked conservation fees, click on availability *
                </div>

                <div class="date-pickers">
                  <v-dialog ref="dialog"
                            persistent
                            v-model="modal1"
                            lazy
                            full-width
                            width="290px"
                            :return-value.sync="activity.check_in">
                    <v-text-field slot="activator"
                                  label="Check-in *"
                                  v-model="activity.check_in"
                                  readonly
                                  :disabled="activity.activity_date === ''"
                                  prepend-icon="event"
                                  class="date-input"></v-text-field>
                    <v-date-picker v-model="activity.check_in"
                                   :min="start_date"
                                   @input="retrievePricingSchedule()"
                                   scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal1 = false" class="earthwerk-font">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog.save(activity.check_in)" class="earthwerk-font">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>

                  <v-dialog ref="dialog1"
                            persistent
                            v-model="modal2"
                            lazy
                            full-width
                            width="290px"
                            :return-value.sync="activity.check_out">
                    <v-text-field slot="activator"
                                  label="Check-out *"
                                  v-model="activity.check_out"
                                  readonly
                                  :disabled="activity.activity_date === ''"
                                  prepend-icon="event"
                                  class="date-input"></v-text-field>
                    <v-date-picker v-model="activity.check_out"
                                   :min="activity.check_in"
                                   scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal2 = false" class="earthwerk-font">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog1.save(activity.check_out)" class="earthwerk-font">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>

                <div class="fee-sections">
                  <div class="fee-section">
                    <h3 class="earthwerk-font">Conservation entry fees</h3>
                    <guests></guests>
                  </div>

                  <div class="fee-section">
                    <h3 class="earthwerk-font">Vehicle entry fees</h3>
                    <vehicle />
                  </div>
                </div>

                <small class="required-notice">*indicates required field</small>
              </div>
            </v-tab-item>

            <!-- Availability Tab -->
            <v-tab-item key="availability">
              <div class="tab-content">
                <v-dialog ref="dialog4"
                          persistent
                          v-model="modal3"
                          lazy
                          full-width
                          width="290px"
                          :return-value.sync="activity.activity_date">
                  <v-text-field slot="activator"
                                label="Activity Date *"
                                v-model="activity.activity_date"
                                readonly
                                id="activity_date"
                                prepend-icon="event"
                                class="date-input"></v-text-field>
                  <v-date-picker v-model="activity.activity_date"
                                 scrollable
                                 :min="start_date"
                                 @input="checkAvailability()">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="modal3 = false" class="earthwerk-font">Cancel</v-btn>
                    <v-btn flat color="primary" @click="$refs.dialog4.save(activity.activity_date)" class="earthwerk-font">OK</v-btn>
                  </v-date-picker>
                </v-dialog>

                <div class="participant-selectors" v-if="showDates">
                  <div v-if="singleInventory.ranger_marker === false" class="selector-group">
                    <v-autocomplete label="Children"
                                    :items="childSlots_"
                                    v-model="activity.children"
                                    :disabled="activity.activity_date === ''"
                                    prepend-icon="child_friendly"
                                    class="participant-input"></v-autocomplete>

                    <v-autocomplete label="Adults"
                                    :items="adultSlots_"
                                    v-model="activity.adults"
                                    :disabled="activity.activity_date === ''"
                                    prepend-icon="person"
                                    class="participant-input"></v-autocomplete>
                  </div>

                  <div v-else class="selector-group">
                    <v-autocomplete label="No of Rangers"
                                    :items="adultSlots_"
                                    v-model="activity.adults"
                                    :disabled="activity.activity_date === ''"
                                    prepend-icon="security"
                                    class="participant-input"></v-autocomplete>
                  </div>
                </div>

                <div class="date-range-section">
                  <h3 class="earthwerk-font">CHECK-IN & CHECK-OUT DATES</h3>

                  <div class="date-range-pickers">
                    <v-dialog ref="dialogA"
                              persistent
                              v-model="modalA"
                              lazy
                              full-width
                              width="290px"
                              :return-value.sync="activity.check_in">
                      <v-text-field slot="activator"
                                    label="Check-in *"
                                    v-model="activity.check_in"
                                    readonly
                                    :disabled="activity.activity_date === ''"
                                    prepend-icon="event"
                                    class="date-input"></v-text-field>
                      <v-date-picker v-model="activity.check_in"
                                     :min="start_date"
                                     scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modalA = false" class="earthwerk-font">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.dialogA.save(activity.check_in)" class="earthwerk-font">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>

                    <v-dialog ref="dialogB"
                              persistent
                              v-model="modalB"
                              lazy
                              full-width
                              width="290px"
                              :return-value.sync="activity.check_out">
                      <v-text-field slot="activator"
                                    label="Check-out *"
                                    v-model="activity.check_out"
                                    readonly
                                    :disabled="activity.activity_date === ''"
                                    prepend-icon="event"
                                    class="date-input"></v-text-field>
                      <v-date-picker v-model="activity.check_out"
                                     :min="activity.check_in"
                                     scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="modalB = false" class="earthwerk-font">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.dialogB.save(activity.check_out)" class="earthwerk-font">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </div>
                </div>

                <div class="additional-options" v-if="specialActivityOptions">
                  <v-select v-if="singleInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7'"
                            :items="['7:00 PM', '9:00 PM']"
                            label="Select Preferred Time"
                            v-model="activity.time_frame"
                            prepend-icon="access_time"
                            class="option-input"></v-select>

                  <v-select v-if="needsPickupLocation"
                            :items="allPickUpLocations"
                            item-text="location_name"
                            item-value="location_public_id"
                            label="Select Pick Up Location"
                            v-model="activity.pick_up_location"
                            prepend-icon="place"
                            class="option-input"></v-select>
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card-text>

        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="dialog = false" class="cancel-btn earthwerk-font">Cancel</v-btn>
          <v-btn color="primary" @click="makeReservation()" class="reserve-btn earthwerk-font">Make Reservation</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import FrontNavigation from './../Repeated/FrontNavigation'
  import Guests from '../Repeated/Guests'
  import Vehicle from '../Repeated/Vehicle'

  export default {
    data() {
      return {
        active: false,
        menu1: false,
        modal1: false,
        modalA: false,
        modalB: false,
        menu2: false,
        modal2: false,
        start_date: this.$moment().format('YYYY-MM-DD'),
        adjust: false,
        switch1: true,
        booking: false,
        dialog: false,
        dialogA: false,
        dialogB: false,
        dialog4: false,
        availabiltytab: true,
        modal3: false,
        continue_: false,
        showDates: false,
        loadingdialog_: false,
        totalCount: 0,
        activity: {
          days: 0,
          check_in: '',
          check_out: '',
          currency: localStorage.getItem('currency'),
          activity_date: '',
          children: 0,
          adults: 0,
          inventory: {},
          extra_pax_adults: 0,
          extra_pax_children: 0,
          pick_up_location: '',
          time_frame: ''
        }
      }
    },
    beforeCreate() {
      this.$store.dispatch('get_activity', this.$route.params.activity_id)
      this.$store.dispatch('get_all_pick_up_locations')
      this.$store.dispatch('get_activity_images', this.$route.params.activity_id)
    },
    computed: {
      inventoryImages() {
        return this.$store.state.ActivityStore.activity_images
      },
      singleInventory() {
        return this.$store.state.ActivityStore.activity
      },
      allPickUpLocations() {
        return this.$store.state.ActivityStore.pick_up_locations
      },
      specialActivityOptions() {
        return this.singleInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7' ||
          this.singleInventory.public_id === '4b45eed6-d1dd-4301-acb5-eca2a682d7c6' ||
          this.singleInventory.public_id === '66e52cab-43cd-4974-85de-246a731d6905'
      },
      needsPickupLocation() {
        return this.singleInventory.public_id === '648f6bc6-96bd-446c-89c5-e988749bcdf7' ||
          this.singleInventory.public_id === '4b45eed6-d1dd-4301-acb5-eca2a682d7c6' ||
          this.singleInventory.public_id === '66e52cab-43cd-4974-85de-246a731d6905'
      },
      childSlots_() {
        var slots = []
        var available = this.calculateChildMax_
        for (var i = 0; i <= available; i++) {
          slots.push(i)
        }
        return slots
      },
      adultSlots_() {
        var slots = []
        var available = this.calculateAdultMax_
        for (var i = 0; i <= available; i++) {
          slots.push(i)
        }
        return slots
      },
      calculateAdultMax_: function () {
        return (Number(this.activitySlots) - Number(this.total)) + this.activity.adults
      },
      calculateChildMax_: function () {
        return (Number(this.activitySlots) - Number(this.total)) + this.activity.children
      },
      total: function () {
        return Number(this.activity.adults) + Number(this.activity.children)
      }
    },
    methods: {
      storeVehicles: function () {
        localStorage.setItem('vehicle_data', JSON.stringify(this.allVehicles))
      },
      storeConservation: function () {
        localStorage.setItem('conservation_data', JSON.stringify(this.allConservationFees))
      },
      makeReservation: function () {
        this.activity.inventory.price = this.$store.state.ActivityStore.activity_price_at_time
        if (this.activity.check_in === '' || this.activity.check_out === '') {
          this.$notify({
            type: 'warning',
            group: 'foo',
            title: 'Missing Data',
            text: 'You need a check-in and check-out date to proceed',
            classes: 'alert-wrapper'
          })
        } else {
          var data = {
            public_id: this.activity.inventory.public_id,
            name: this.activity.inventory.name,
            date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
            adults: this.activity.adults,
            adult_price: this.activity.inventory.price.adult_price,
            child_price: this.activity.inventory.price.child_price,
            currency: this.activity.inventory.price.currency_type,
            children: this.activity.children,
            ranger_marker: this.activity.inventory.ranger_marker,
            activity_discount: 0,
            discounts: this.activity.inventory.discount,
            discount_status: this.activity.inventory.discount_status,
            extra_pax_adults: 0,
            extra_pax_children: 0,
            time_frame: this.activity.time_frame,
            pick_up_location: this.activity.pick_up_location
          }
          var oldData = JSON.parse(localStorage.getItem('activity_data'))
          this.$store.commit('CHOSEN_ACTIVITIES', oldData)
          this.$store.commit('ADD_ACTIVITY', data)
          localStorage.setItem('activity_data', JSON.stringify(this.chosenInventory))
          this.activity.inventory = {}
          this.activity.date = ''
          this.activity.adults = 0
          this.activity.children = 0
          this.adjustDates(this.activity.check_in, this.activity.check_out)
          this.storeConservation()
          this.storeVehicles()
          this.$router.push({
            name: 'Reservation'
          })
        }
      },
      checkAvailability() {
        this.activity.inventory = this.$store.state.ActivityStore.activity
        if (this.activity.activity_date === '') {
          this.$notify({
            type: 'warning',
            group: 'foo',
            title: 'Missing Data',
            text: 'You need an activity date to proceed',
            classes: 'alert-wrapper'
          })
        } else {
          this.loadingdialog_ = true
          var data = {
            inventory_id: this.$route.params.activity_id,
            date: this.activity.activity_date
          }
          this.$store.dispatch('check_inventory_availability', data)
          this.continue_ = true
          this.showDates = true
          var priceData = {
            date: this.$moment(this.activity.activity_date).format('YYYY-MM-DD'),
            public_id: this.$route.params.activity_id
          }
          this.$store.dispatch('get_activity_with_pricing', priceData)
        }
      },
      retrievePricingSchedule: function () {
        let data = {
          check_in_date: this.activity.check_in
        }
        this.$store.dispatch('get_conservation_fee_by_check_in_date', data)
      }
    },
    components: {
      FrontNavigation,
      Guests,
      Vehicle
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: 'Earthwerk';
    src: url('/fonts/Earthwerk.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  .earthwerk-font {
    font-family: 'Earthwerk', sans-serif;
    letter-spacing: 1px;
  }

  .activity-page {
    background-color: #f9f9f9;
    min-height: 100vh;
  }

  .activity-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .gallery-section {
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .gallery-container, .single-image-container {
    width: 100%;
    height: 500px;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .details-section {
    background: white;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .details-header {
    margin-bottom: 25px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
  }

  .activity-title {
    font-family: 'Earthwerk', sans-serif;
    color: #333;
    font-size: 32px;
    margin-bottom: 15px;
    letter-spacing: 0.5px;
  }

  .price-display {
    display: flex;
    gap: 20px;
    margin-top: 15px;
  }

  .price-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .price-label {
    font-size: 16px;
    color: #666;
  }

  .price-value {
    font-size: 18px;
    font-weight: 600;
    color: #74a533;
  }

  .description-section {
    color: #555;
    line-height: 1.8;
    font-size: 16px;
    margin-bottom: 30px;
  }

    .description-section > > > p {
      margin-bottom: 15px;
    }

    .description-section > > > a {
      color: #74a533;
      text-decoration: none;
    }

      .description-section > > > a:hover {
        text-decoration: underline;
      }

  .book-now-btn {
    margin-top: 20px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .booking-dialog {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .dialog-header {
    background-color: #74a533;
    color: white;
    padding: 20px 24px;
  }

    .dialog-header h2 {
      font-family: 'Earthwerk', sans-serif;
      font-size: 24px;
      margin: 0;
    }

  .dialog-content {
    padding: 24px;
  }

  .tab-content {
    padding: 15px 0;
  }

  .notice-text {
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 6px;
  }

  .date-pickers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 25px;
  }

  .date-input {
    margin-bottom: 15px;
  }

  .fee-sections {
    display: grid;
    gap: 25px;
  }

  .fee-section {
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 8px;
  }

    .fee-section h3 {
      margin-top: 0;
      margin-bottom: 15px;
      color: #444;
      font-size: 18px;
    }

  .required-notice {
    display: block;
    margin-top: 20px;
    color: #999;
    font-size: 12px;
    text-align: right;
  }

  .participant-selectors {
    margin: 20px 0;
  }

  .selector-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .participant-input {
    margin-bottom: 15px;
  }

  .date-range-section {
    margin-top: 30px;
  }

    .date-range-section h3 {
      color: #444;
      font-size: 18px;
      margin-bottom: 15px;
    }

  .date-range-pickers {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .additional-options {
    margin-top: 25px;
  }

  .option-input {
    margin-bottom: 15px;
  }

  .dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #eee;
  }

  .cancel-btn {
    margin-right: 10px;
  }

  .reserve-btn {
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  /* Responsive adjustments */
  @media (max-width: 960px) {
    .activity-container {
      padding: 15px;
    }

    .gallery-container, .single-image-container {
      height: 400px;
    }

    .activity-title {
      font-size: 28px;
    }

    .price-display {
      flex-direction: column;
      gap: 10px;
    }

    .date-pickers, .selector-group, .date-range-pickers {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 600px) {
    .gallery-container, .single-image-container {
      height: 300px;
    }

    .details-section {
      padding: 20px;
    }

    .activity-title {
      font-size: 24px;
    }

    .price-label {
      font-size: 14px;
    }

    .price-value {
      font-size: 16px;
    }

    .description-section {
      font-size: 15px;
    }
  }
</style>
